import React from 'react';

import { useAppSelector, useAppDispatch } from 'redux/hooks';
import { getCurrentUserSellers } from 'redux/sellers/actions';
import { setUserRegistrationSteps } from 'redux/users/actions';
import {IframePage} from "../types/iframe";
import {withParamsFrame} from "../HOCs";

const ServiceAgreement: React.FC<IframePage> = ({ params }) => {
    const dispatch = useAppDispatch();

    const { userId, accessToken, registrationSteps, allSellers } = useAppSelector(({ users, sellers }) => ({
        userId: users.currentUser.data.id,
        accessToken: users.currentUser.data.accessToken,
        registrationSteps: users.currentUser.registrationSteps,
        allSellers: sellers.allSellers
    }))

    React.useEffect(() => {
        if(registrationSteps.data?.completeRegistration && userId && accessToken && allSellers.length <= 0) {
            dispatch(getCurrentUserSellers({id: userId}) as any)
        }
    }, [registrationSteps, accessToken, userId])
    
    React.useEffect(() => {
        const messageHandler = function (e: MessageEvent) {
            if (e.origin === "https://lk.market") {
                if (registrationSteps.data && registrationSteps.data?.completeRegistration && !registrationSteps.data?.acceptServiceAgreement) {
                    dispatch(setUserRegistrationSteps(["COMPLETE_REGISTRATION", e.data.progress]))
                }
            }
        }

        window.addEventListener("message", messageHandler);
        return () => window.removeEventListener("message", messageHandler);
    }, [registrationSteps])

    return (
        <>
            <div className='xs:mx-3'>
                <iframe className={'page-iframe'} src={`https://lk.market/welcome/service-agreement${params}`}
                    title="Service agreement"
                    width="100%"
                    height={"calc(100vh-64px)"}

                ></iframe>
            </div>
        </>
    );
};

export default withParamsFrame(ServiceAgreement);
